/**
 * @fileoverview POST handler for the "/alloys/partners/:alloys_id/breaking_changes_export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnersAlloysIdBreakingChangesExportCacheKeys } from "./constants";
import type { PostAlloysPartnersAlloysIdBreakingChangesExportProps } from "./types";

export const postAlloysPartnersAlloysIdBreakingChangesExport = reactQueryMutationAdapter(
  alloysPartnersAlloysIdBreakingChangesExportCacheKeys,
  (props: PostAlloysPartnersAlloysIdBreakingChangesExportProps): Promise<void> => {
    return fetch(`/alloys/partners/shopify/breaking_changes_export`, "POST", props, undefined, {});
  }
);
